export default "__VITE_ASSET__fbd09e3e__"